var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.39 251.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e40e87;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m162.68,70c-66.76-10.5-105.91,45.36-103.89,49.13,20.25,37.88,84.76,52.51,84.76,52.51,69.01-4.88,97.89-52.51,97.89-52.51-25.5-34.51-78.76-49.13-78.76-49.13Zm-9.39,14.11c28.13,1.4,31.88,29.36,31.88,29.36h-14.63c-.75-12.75-17.25-17.63-17.25-17.63v-11.73Zm-9.37,1.17v11.73s-16.5,4.88-17.25,17.63h-14.63s3.75-27.95,31.88-29.35Zm-74.64,34.89c5.63-15.47,49.88-38.2,49.88-38.2-34.88,38.59,1.5,75.42,1.5,75.42-32.63-9.38-51.38-37.22-51.38-37.22Zm76.78,37.22s-30.83-5.69-34.02-33.01h13.88s6.54,17.25,20.15,18.75v14.25Zm-9.27-38.22c0-7.48,6.06-13.54,13.54-13.54s13.54,6.06,13.54,13.54-6.06,13.54-13.54,13.54-13.54-6.06-13.54-13.54Zm14.35,37.05v-14.25c13.61-1.5,20.15-18.75,20.15-18.75h13.88c-3.2,27.31-34.02,33.01-34.02,33.01Zm26.88,1.17s36.38-36.83,1.5-75.42c0,0,44.26,22.73,49.88,38.2,0,0-18.75,27.85-51.38,37.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.49,
    y: 35.37,
    width: 9.06,
    height: 24.5,
    transform: "translate(-9.39 48.04) rotate(-22.51)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.62,
    y: 26.37,
    width: 9.06,
    height: 24.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 180.64,
    y: 35.37,
    width: 9.06,
    height: 24.5,
    transform: "translate(54.04 -91.52) rotate(32.27)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.14,
    y: 181.97,
    width: 9.06,
    height: 24.5,
    transform: "translate(431.56 302.56) rotate(157.49)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.01,
    y: 190.97,
    width: 9.06,
    height: 24.5,
    transform: "translate(301.08 406.45) rotate(180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.98,
    y: 181.97,
    width: 9.06,
    height: 24.5,
    transform: "translate(111.32 420.65) rotate(-147.73)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision01);
export default __webpack_public_path__ + "static/media/vision-01.4af9c7e7f9f7967257934326a9d9764c.svg";
export { ForwardRef as ReactComponent };